import { Routes } from '@angular/router';
import { AuthGuard } from '@shared/core';
import { DefaultLayoutComponent } from '@shared/ui';

export const routes: Routes = [
    {
        path: '',
        canActivate: [AuthGuard],
        component: DefaultLayoutComponent,
        children: [
            {
                path: 'home',
                loadChildren: () => import('./home/home.routes').then(m => m.routes),
            },
            {
                path: 'claims',
                loadChildren: () => import('./claims/claims.routes').then(m => m.routes),
            },
            {
                path: 'insurance-policies',
                loadChildren: () => import('./insurance-policies/insurance-policies.routes').then(m => m.routes),
            },
            {
                path: 'book',
                loadChildren: () => import('./booking/booking.routes').then(m => m.bookingRoutes),
            },
            {
                path: 'settings',
                loadChildren: () => import('@shared/settings-feature').then(m => m.routes),
            },
            {
                path: 'contact',
                loadChildren: () => import('./contact/contact.routes').then(m => m.routes),
            },
            { path: '**', redirectTo: 'home', pathMatch: 'full' },
        ],
    },
];
